/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * HomeAdvisorModalService is responsible for opening th home advisor modal
 *
 * @module enervee_utils.home_advisor
 */
HomeAdvisorModalService.$inject = [
    'IndexService',
    'UtilService',
];
function HomeAdvisorModalService(
    IndexService,
    UtilService
) {
    let _openModalCallback = null;
    var _pub = {
        product: null,
        homeAdvisorEmbedLink: null,
        openModal: openModal,
        registerOpenModalCallback: registerOpenModalCallback,
        registerProduct: registerProduct
    };

    return _pub;

    /**
     * Opens the HomeAdvisor modal for the given categoryId
     *
     * @param categoryId
     */
    function openModal(categoryId) {
        updateHomeAdvisorLink(categoryId);
        _openModalCallback();
        IndexService.openModal('#modal-home-advisor');
    }

    /**
     * Registers a product for tracking purposes.
     * @param product
     */
    function registerProduct(product) {
        _pub.product = product;
    }

    function registerOpenModalCallback(callback) {
        _openModalCallback = callback;
    }

    /**
     * Sets up the home advisor link based on the provided category id or the previously registered product.
     * @param categoryId
     */
    function updateHomeAdvisorLink(categoryId) {
        if (_pub.product && categoryId === undefined) {
            categoryId = _pub.product.category.id;
        }

        var homeAdvisorBaseEmbedUrl = UtilService.getSiteSetting('home_advisor_base_embed_url');
        var homeAdvisorCategoryMappings = UtilService.getSiteSetting('home_advisor_category_mappings');

        var homeAdvisorNode = null;
        try {
            homeAdvisorNode = homeAdvisorCategoryMappings[categoryId];
        } catch (e) {
            $log.warn("HomeAdvisor category missing for category id " + categoryId + ". Please add it to the home_advisor_category_mappings site settings.");
        }

        if (homeAdvisorNode) {
            _pub.homeAdvisorEmbedLink = homeAdvisorBaseEmbedUrl + homeAdvisorNode;
        }
    }

}

module.exports = HomeAdvisorModalService;
